import styled from '@emotion/styled'
import { Primary500, Gray900 } from '@mehilainen/design-system-tokens/colors'
import { ArrowLeft } from '@mehilainen/hive-customer/icons'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { v4 as uuid } from 'uuid'

import { scale } from '../../../utils/scale'
import { CenteredRowFlex } from '../../Layout/Layout'
import { Text } from '../../Typography/Typography'

const StyledButton = styled.button`
  padding: ${scale(1.5)};
  padding-bottom: ${scale(1.25)};
  background: white;
  border-radius: ${scale(2)};
  border: 1.4px solid ${Primary500};
  cursor: pointer;
`

const Container = styled(CenteredRowFlex)`
  ${StyledButton} {
    margin-right: 12px;
  }
`

interface Props {
  onBack(): void
  className?: string
}

const BackButton: React.FC<Props> = ({ onBack, className }) => {
  const { t } = useTranslation()
  const backButtonId = useMemo(() => `backButton-${uuid()}`, [])

  return (
    <Container className={className}>
      <StyledButton onClick={onBack} id={backButtonId}>
        <ArrowLeft />
      </StyledButton>
      <Text
        $size={300}
        $weight="Regular"
        $height="Large"
        $color={Gray900}
        as="label"
        htmlFor={backButtonId}
      >
        {t('common.back')}
      </Text>
    </Container>
  )
}

export default styled(BackButton)``
